export const en = {
    securityService:'Security service',
    traceService:'Trace service',
    storageService:'Cloud storage service',
    recoveryService:'Data recovery service',
    imeiNumber:'IMEI number:',
    currentPackage:'Current package',
    remaining:'Remaining',
    min:'minutes',
    day:'Day',
    strips:'Strips',
    total1:'Total',
    loading:'Loading...',
    continuousAnnualPackage:'Continuous annual package',
    continuousRecording:'Continuous recording',
    continuousMonthlyPackage:'Continuous monthly package',
    oneWeekVIP:'One-week VIP',
    packageContent:'Package content',
    packageContent1:'1. Unlimited sound security time is given, valid for one year',
    packageContent2:'2. During the validity period of the cloud service, the sound security storage is valid for 90 days. All cloud storage data will be cleared 30 days after the cloud service expires. Please renew in time to avoid data loss',
    packageContent3:'3. This is a virtual product and no refund will be given once sold',
    packageContent4:'4. This package can only be used for this device. Switching to other devices requires re-purchase',
    payment:'Payment method',
    weChatPayment:'WeChat payment',
    alipayPayment:'Alipay payment',
    total:'Total:',
    confirmAndPay:'Confirm and pay',
}


